<career-content-job [job]="job" [loading]="loading"></career-content-job>
